import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Collapse,
  Box,
  Typography,
  Divider,
  Badge,
} from '@mui/material';
import {
  Dashboard,
  EventSeat,
  People,
  Settings,
  Chat,
  CalendarToday,
  ExpandLess,
  ExpandMore,
  BookOnline,
  Notifications,
  Restaurant,
  AdminPanelSettings,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const drawerWidth = 280;

const Sidebar = ({ open, onClose, unreadMessages = 0 }) => {
  const [openSubmenu, setOpenSubmenu] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useAuth();

  const handleSubmenuToggle = (key) => {
    setOpenSubmenu(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleNavigation = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const menuItems = [
    {
      title: 'Dashboard',
      icon: <Dashboard />,
      path: '/admin',
      adminOnly: true
    },
    {
      title: 'Bookings',
      icon: <BookOnline />,
      path: '/admin/bookings',
      adminOnly: true
    },
    {
      title: 'Calendar View',
      icon: <CalendarToday />,
      path: '/admin/calendar',
      adminOnly: true
    },
    {
      title: 'Tables',
      icon: <EventSeat />,
      path: '/admin/tables',
      adminOnly: true
    },
    {
      title: 'Customers',
      icon: <People />,
      path: '/admin/customers',
      adminOnly: true
    },
     {
      title: 'MVE API',
      icon: <People />,
      path: '/admin/mveapi',
      adminOnly: true
    },
    {
      title: 'Chat Messages',
      icon: <Chat />,
      path: '/admin/chat',
      adminOnly: true,
      badge: unreadMessages
    },
    {
      title: 'Settings',
      icon: <Settings />,
      path: '/admin/settings',
      adminOnly: true
    }
  ];

  const customerMenuItems = [
    {
      title: 'Dashboard',
      icon: <Dashboard />,
      path: '/dashboard'
    },
    {
      title: 'Book Table',
      icon: <EventSeat />,
      path: '/book-table'
    },
    {
      title: 'Bookings',
      icon: <BookOnline />,
      path: '/my-bookings'
    }
  ];

  // const renderMenuItem = (item) => {
  //   if (item.adminOnly && !isAdmin) return null;

  //   return (
  //     <ListItem key={item.path} disablePadding>
  //       <ListItemButton
  //         selected={isActive(item.path)}
  //         onClick={() => handleNavigation(item.path)}
  //         sx={{
  //           '&.Mui-selected': {
  //             backgroundColor: 'primary.light',
  //             '&:hover': {
  //               backgroundColor: 'primary.light',
  //             },
  //           },
  //         }}
  //       >
  //         <ListItemIcon sx={{ color: isActive(item.path) ? 'primary.main' : 'inherit' }}>
  //           {item.badge ? (
  //             <Badge badgeContent={item.badge} color="error">
  //               {item.icon}
  //             </Badge>
  //           ) : (
  //             item.icon
  //           )}
  //         </ListItemIcon>
  //         <ListItemText 
  //           primary={item.title}
  //           sx={{ 
  //             color: isActive(item.path) ? 'primary.main' : 'inherit',
  //             fontWeight: isActive(item.path) ? 'bold' : 'normal'
  //           }}
  //         />
  //       </ListItemButton>
  //     </ListItem>
  //   );
  // };

  const renderMenuItem = (item) => {
  if (item.adminOnly && !isAdmin) return null;

  return (
    <ListItem key={item.path} disablePadding>
      <ListItemButton
        selected={isActive(item.path)}
        onClick={() => handleNavigation(item.path)}
        sx={{
          '&.Mui-selected': {
            backgroundColor: 'black', // Black background for selected item
            color: 'white', // White text for selected item
            '&:hover': {
              backgroundColor: 'black', // Keep black on hover
            },
          },
        }}
      >
        <ListItemIcon sx={{ color: isActive(item.path) ? 'white' : 'inherit' }}>
          {item.badge ? (
            <Badge badgeContent={item.badge} color="error">
              {item.icon}
            </Badge>
          ) : (
            item.icon
          )}
        </ListItemIcon>
        <ListItemText 
          primary={item.title}
          sx={{ 
            color: isActive(item.path) ? 'white' : 'inherit',
            fontWeight: isActive(item.path) ? 'bold' : 'normal'
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: 'background.paper',
          borderRight: '1px solid',
          borderColor: 'divider',
        },
      }}
    >
   <Box sx={{ height: '64px', bgcolor: '#000', color: '#fff', px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
  <Box display="flex" alignItems="center">
    <Restaurant sx={{ mr: 1, color: '#fff' }} />
    <Typography variant="h6" color="#fff">
MVE System v2.0
    </Typography>
  </Box>
</Box>


      <List sx={{ px: 1 }}>
        {isAdmin ? (
          // Admin menu items
          menuItems.map(renderMenuItem)
        ) : (
          // Customer menu items
          customerMenuItems.map(renderMenuItem)
        )}
      </List>

      <Box sx={{ mt: 'auto', p: 2 }}>
        <Divider />
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            MVE System v2.0
          </Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar; 